import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=4154cd20&scoped=true&"
import script from "./loginView?vue&type=script&lang=js&"
export * from "./loginView?vue&type=script&lang=js&"
import style0 from "./loginView.scss?vue&type=style&index=0&id=4154cd20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154cd20",
  null
  
)

export default component.exports